export enum UploadBatchType {
	Unsupported = "b22a7b12-9591-4d1f-b20c-9fc944ea1da4",
	NativeUpload = "cbe6f05f-ea98-4919-babd-40594884a6f4",
	ProductionUpload = "9a8eb8be-29ed-45d9-86e9-3a911ed3f0f3",
	MergeDocs = "7eb93f40-e64d-4738-bf60-2e73b96f11ac",
	ImportProduction = "ae7b70fa-e8c1-4475-8e59-775c5c253cba"
}

export enum UploadBatchTypeLookup {
	'b22a7b12-9591-4d1f-b20c-9fc944ea1da4' = 'Unsupported',
	'cbe6f05f-ea98-4919-babd-40594884a6f4' = 'Native Upload',
	'9a8eb8be-29ed-45d9-86e9-3a911ed3f0f3' = 'Production Upload',
	'7eb93f40-e64d-4738-bf60-2e73b96f11ac' = 'Merge Docs',
	'ae7b70fa-e8c1-4475-8e59-775c5c253cba' = 'Import Production'
}
